import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setBackLayout } from "../../redux/slice/system";

import { option_sidebar } from "../../service/option/common";

import ImgLogo from "../../images/logo.png";

import { Sidebar } from "primereact/sidebar";
import { PanelMenu } from "primereact/panelmenu";
import { classNames } from "primereact/utils";

export default function BackSidebar(props) {
  let { model, LayoutCss } = props;
  const route_location = useLocation();
  const route_params = useParams();
  const navigate = useNavigate();
  const redux_user = useSelector((state) => state.user);
  const system = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const [menuItem, setMenuItem] = useState([]);

  const renderExpand = (item, options, layer) => {
    return (
      <>
        <a
          className={options.className}
          style={{ paddingLeft: 1 + layer * 0.8 + "rem" }}
          onClick={options.onClick}
        >
          {options.iconClassName !== "p-menuitem-icon" && (
            <span className={classNames(options.iconClassName)}></span>
          )}
          <span className={classNames(options.labelClassName, "mr-auto")}>
            {item.label}
          </span>
          <i
            className={`pi pi-angle-down -rotate-${
              item.expanded ? "180" : "0"
            } transition-all transition-duration-200 transition-ease-in-out`}
          ></i>
        </a>
      </>
    );
  };

  const renderLink = (item, options, layer) => {
    return (
      <>
        <a
          className={options.className}
          style={{ paddingLeft: 1 + layer * 0.8 + "rem" }}
          onClick={options.onClick}
        >
          <span className={classNames(options.labelClassName, "mr-auto")}>
            {item.label}
          </span>
        </a>
      </>
    );
  };

  const matchExpand = (path) => {
    let { pathname } = route_location;

    return pathname.indexOf(path) !== -1;
  };

  const matchPath = (path) => {
    let { pathname } = route_location;

    return (model === "back" && pathname.indexOf(path) !== -1) ||
      (model === "teach" && pathname === path)
      ? "menu-active"
      : "";
  };

  // 設定 menu 項目
  useEffect(() => {
    let { mainType, subType } = route_params;

    function formatRoutes(rawData) {
      let temp = [];

      function formatRoute(childs, layer) {
        let tempChild = [];
        layer++;

        childs.forEach((child) => {
          if (child.items && child.items.length > 0) {
            tempChild.push({
              label: child.label,
              expanded: matchExpand(child.path),
              template: (item, options) => renderExpand(item, options, layer),
              items: formatRoute(child.items, layer),
            });
          } else {
            tempChild.push({
              label: child.label,
              className: matchPath(child.path),
              template: (item, options) => renderLink(item, options, layer),
              command: (e) => navigate(child.path),
            });
          }
        });

        return tempChild;
      }

      rawData.forEach((route) => {
        if (route.items?.length > 0) {
          temp.push({
            label: route.label,
            expanded: matchExpand(route.path),
            template: (item, options) => renderExpand(item, options),
            items: formatRoute(route.items, 0),
          });
          return;
        }

        temp.push({
          label: route.label,
          className: matchPath(route.path),
          command: (e) => navigate(route.path),
        });
      });

      return temp;
    }

    let routes = [
      {
        label: "功能總覽",
        path: "/back/home",
      },
      ...option_sidebar,
    ];

    setMenuItem(formatRoutes(routes));
  }, [route_location, redux_user.userControl, redux_user.userDetail]);

  return (
    <>
      <div
        className={classNames(LayoutCss["layout-sidebar"], {
          [LayoutCss["layout-sidebar-teach"]]: model === "teach",
        })}
      >
        <Sidebar
          className={classNames({
            "sidebar-teach": model === "teach",
            "sidebar-control":
              model === "back" &&
              redux_user.userControl?.sccs === 1 &&
              redux_user.userDetail === null,
          })}
          visible={system.backLayout.isSideShow}
          modal={!system.backLayout.isSideFixed}
          dismissable={!system.backLayout.isSideFixed}
          showCloseIcon={false}
          onHide={() =>
            dispatch(
              setBackLayout({
                isSideShow: false,
              })
            )
          }
        >
          <div className={`${LayoutCss["layout-logo"]} mt-5 mb-2`}>
            <img src={ImgLogo} />
          </div>

          <div className="w-11 text-center text-white text-lg block lg:hidden mx-auto mb-3">
            {redux_user?.userCompany?.name}
          </div>

          <PanelMenu
            className={classNames({
              "panelmenu-teach": model === "teach",
              "panelmenu-control":
                model === "back" &&
                redux_user.userControl?.sccs === 1 &&
                redux_user.userDetail === null,
            })}
            model={menuItem}
          />
        </Sidebar>
      </div>
    </>
  );
}
